// ============================================================================
// JARVISTRAVEL - DEMO DATA PURGE (JAR-1992)
//
// The demo lets a visitor add memories, receipt scans, flights and travel
// preferences to the sample trips. That data persists in browser storage keyed
// by SAMPLE TRIP id (or, for preferences, a demo-only key) — not by the demo
// session — so `leaveDemo` cleared the demo flag and identity and left the data
// behind. The next visitor to open the demo in that browser then started with
// the last one's journal, scans and flights (demoIdentity.ts had long CLAIMED
// leaving the demo wiped this; nothing did).
//
// This removes exactly what a demo writes, keyed to the demo's own sample trips.
// A signed-in user's data lives under THEIR trip ids (never a sample id) and, for
// preferences, in the live sidecar the demo never touches, so it is left alone —
// which matters because the plan gate opens the demo with a real session
// underneath. Called when a demo starts and when it ends (App.tsx).
// ============================================================================

import { SAMPLE_TRIPS } from './sampleData';
import { clearJournalForTrip } from '@/app/api/journal';
import { clearStoredFlights } from '@/app/api/flightsStore';
import { clearDemoPreferences } from '@/app/api/preferences';
import { clearDemoShares } from '@/app/api/share';
import { clearStoredScans } from './receiptScanStore';
import { clearDemoStays } from './demoStaysStore';

/**
 * Erase everything a demo session writes to browser storage. Idempotent and
 * best-effort (each store's clear swallows storage errors). Run it both when a
 * demo starts — so a crash or killed tab that skipped the leave path can't seed
 * the next demo — and when it ends.
 */
export function purgeDemoData(): void {
  for (const trip of SAMPLE_TRIPS) {
    clearJournalForTrip(trip.id);
    clearStoredScans(trip.id);
    clearStoredFlights(trip.id);
    clearDemoStays(trip.id);
  }
  clearDemoPreferences();
  clearDemoShares();
}
